module.exports = __webpack_public_path__ + "static/img/a.f73f037.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/a.png
// module id = Af78
// module chunks = 1